import { render } from "./ExPagantesTable.vue?vue&type=template&id=06dd1018"
import script from "./ExPagantesTable.vue?vue&type=script&lang=js"
export * from "./ExPagantesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__